export default function PageTabHeader({
  tabs,
  activeTab,
  onTabChange,
  variant = "pill",
}) {
  const isUnderline = variant === "underline";

  return (
    <div
      className={`tab-header-scroll flex items-center gap-0.5 overflow-x-auto max-md:pb-1.5 px-0.5 md:w-full md:gap-0 md:overflow-x-visible md:pb-0 md:pr-0 ${
        isUnderline
          ? "border-[var(--bxh-border)]"
          : "md:rounded bg-[var(--color-background-header)] py-1 px-0.5"
      }`}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className="group relative shrink-0 flex-none cursor-pointer text-xs font-medium whitespace-nowrap rounded transition-colors md:flex-1 md:max-w-none md:text-sm"
          >
            <div
              className={`px-[11px] py-[5px] flex items-center justify-center gap-1 transition-colors ${
                isUnderline
                  ? isActive
                    ? "font-semibold"
                    : "font-medium"
                  : isActive
                    ? "bg-[var(--color-background-header-active)] md:bg-transparent group-hover:brightness-95 md:group-hover:bg-[var(--bxh-row-hover)] md:group-hover:brightness-100"
                    : "group-hover:bg-[var(--bxh-row-hover)]"
              } ${!isUnderline ? "rounded" : "px-[15px]"}`}
            >
              <span
                className={`transition-colors ${
                  isActive
                    ? isUnderline
                      ? "kbv-bxh-fg font-semibold"
                      : "kbv-bxh-tab-active font-semibold"
                    : "kbv-bxh-tab-idle font-medium"
                }`}
              >
                {tab.label}
              </span>
            </div>
            {!isUnderline && isActive && (
              <span className="hidden md:block absolute w-[60%] -bottom-1 left-1/2 -translate-x-1/2 h-[2.5px] bg-[var(--bxh-primary)] rounded-full transition-all duration-300" />
            )}
          </button>
        );
      })}
    </div>
  );
}
